module.exports = __webpack_public_path__ + "static/media/session.7011c035.jpg";